/* eslint-disable no-unused-vars */
import React from 'react';
import { useIsMobileScreen } from '../../../hooks/useWindowSize';
import { Action, ActionTypes } from '../../../contexts/reducers/map-reducer';

import { Dealer } from '../../../models/dealer';
import mapContext from '../../../contexts/map-context';

// eslint-disable-next-line no-shadow
export enum Direction {
  In,
  Out,
}

const dispatchHoverActionByDirection = (
  dispatch: React.Dispatch<Action>,
  direction: Direction,
  dealer?: Dealer,
) => {
  switch (direction) {
    case Direction.In:
      dispatch({ type: ActionTypes.setHoveredDealer, payload: dealer });
      break;

    case Direction.Out:
      dispatch({ type: ActionTypes.setHoveredDealer, payload: null });
      break;

    default:
      break;
  }
};

export const handleHover = (direction: Direction, dealer?: Dealer) => {
  const isMobileScreen = useIsMobileScreen();
  const dispatch = mapContext.useMapDispatch();

  return () => {
    if (!isMobileScreen) {
      dispatchHoverActionByDirection(dispatch, direction, dealer);
    }
  };
};
